import classNames from "classnames";
import { TimeUnit, TimeUnitLabels } from "./BudgetAssumptionsTypes";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "components/common/dropdown/DropDownV2";
import { LuChevronsUpDown } from "react-icons/lu";

interface TimeUnitSelectorProps {
  value: TimeUnit;
  onChange: (newValue: TimeUnit) => void;
  width?: string;
}

export const TimeUnitSelector: React.FC<TimeUnitSelectorProps> = ({ value, onChange, width }) => {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <div
          className={classNames(
            "flex items-center flex-row absolute top-2.5 right-0 p-0 text-regular-3 text-left rounded-xl cursor-pointer",
            width
          )}
        >
          <span className="w-full p-1">{value.toString() || "Select Time Unit"}</span>
          <span className="flex flex-row pr-3 rounded-xl rounded-l-none">
            <LuChevronsUpDown />
          </span>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="min-w-fit">
        <DropdownMenuGroup className="flex flex-col max-h-64 overflow-y-auto gap-1">
          {Object.entries(TimeUnitLabels).map(([timeUnit, label]) => (
            <DropdownMenuItem key={timeUnit} onClick={() => onChange(timeUnit as TimeUnit)}>
              <span>{label}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TimeUnitSelector;
